/**
 * The ?job=<id> link - Back to job on the task page, a scheduled run's Slack
 * reminder - expands its job once and then leaves the URL, like ?manage=.
 * Left in the URL, every list refetch expanded the job again.
 */

export type JobDeepLink = {
  /** The job to expand, or null for a job this list does not have. */
  expandJobId: number | null;
  /** The URL search without the job parameter. */
  search: string;
};

/** Null while there is nothing to take: no job parameter, or no list yet. */
export function takeJobDeepLink(
  search: string,
  listedJobIds: readonly number[] | null,
): JobDeepLink | null {
  const params = new URLSearchParams(search);
  const raw = params.get("job");
  if (raw == null || listedJobIds == null) return null;
  params.delete("job");
  const jobId = Number(raw);
  return {
    expandJobId:
      Number.isInteger(jobId) && listedJobIds.includes(jobId) ? jobId : null,
    search: params.toString(),
  };
}
